import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { WHATSAPP_REPLY_BUTTON_TITLE_MAX, WHATSAPP_MAX_REPLY_BUTTONS, WHATSAPP_MAX_LIST_ROWS, WHATSAPP_MAX_LINK_BUTTONS } from "./chatbotWhatsAppLimits";

/**
 * Popup com regras e possibilidades de botões com link no chatbot (WhatsApp).
 */
export default function ChatbotButtonLinkHelpDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <LinkIcon color="primary" fontSize="small" />
        Botões com link no WhatsApp
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" paragraph>
          Use o modo <strong>Link</strong> para enviar um botão clicável que abre uma página no navegador do
          cliente. O formato de envio é ajustado automaticamente conforme o canal WhatsApp configurado.
        </Typography>

        <Typography variant="subtitle2" gutterBottom>
          Regras gerais
        </Typography>
        <List dense disablePadding sx={{ mb: 2 }}>
          <ListItem disableGutters>
            <ListItemText
              primary={`Até ${WHATSAPP_MAX_REPLY_BUTTONS} botões de resposta nativos; de ${WHATSAPP_MAX_REPLY_BUTTONS + 1} a ${WHATSAPP_MAX_LIST_ROWS} opções, enviamos como lista interativa. Rótulo com no máximo ${WHATSAPP_REPLY_BUTTON_TITLE_MAX} caracteres.`}
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText
              primary={`No máximo ${WHATSAPP_MAX_LINK_BUTTONS} botão com link por passo (limite do WhatsApp).`}
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText primary="A URL deve começar com http:// ou https://." />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText primary="Botões de link não criam subpasso no fluxo — o cliente sai para o site e não volta uma resposta ao chatbot." />
          </ListItem>
        </List>

        <Typography variant="subtitle2" gutterBottom>
          Como o WhatsApp envia (automático)
        </Typography>
        <List dense disablePadding sx={{ mb: 2 }}>
          <ListItem disableGutters>
            <ListItemText
              primary="Somente 1 botão de link"
              secondary="Vira um botão clicável nativo (CTA URL) na conversa."
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText
              primary="Link misturado com botões de resposta"
              secondary="As respostas rápidas seguem no fluxo do chatbot; o link é incluído no corpo da mensagem (também clicável). O WhatsApp não permite botão CTA e resposta rápida na mesma mensagem interativa."
            />
          </ListItem>
        </List>

        <Typography variant="subtitle2" gutterBottom>
          Dicas
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, color: "text.secondary" }}>
          <Typography component="li" variant="body2" sx={{ mb: 0.75 }}>
            Prefira rótulos curtos e claros, como &quot;Ver site&quot; ou &quot;Rastrear pedido&quot;.
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 0.75 }}>
            Para vários contatos ou URLs, use links no texto da mensagem — o botão Link fica reservado a um CTA.
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 0.75 }}>
            Para levar o cliente a uma etapa do fluxo, use botão de resposta (sem link), não link.
          </Typography>
          <Typography component="li" variant="body2">
            Variáveis de contexto (ex.: <code>$nomecliente</code>) podem ser usadas na URL, se configuradas no passo.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" size="small">
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
}
